export const isNotBlank = (str) => {
  return str !== null && str && str.trim().length > 0;
};

export const isBlank = (str) => {
  return !isNotBlank(str);
};

export const checkStrNA = (str) => {
  return isNotBlank(str) ? str : 'N/A';
};

export const splitStr = (str, separator) => {
  if (isBlank(str)) {
    return [];
  }
  return str.split(separator);
};

/**
 * 数字转百分比字符串
 * @param {number} num 数字
 * @param {number} precision 精度
 */
export const numToPercentStr = (num, precision = 4) => {
  if (isNaN(num)) {
    return 'N/A';
  }

  // 将数字乘以 100 并转换为字符串
  let percentStr = (num * 100).toFixed(precision);

  // 使用 parseFloat 去除不必要的尾随零
  let trimmedPercentStr = parseFloat(percentStr).toString();

  return `${trimmedPercentStr}%`;
};

/**
 * 根据 \n 符号分割字符串为数组
 * @param {string} str 字符串
 * @param {string} separator 分隔符
 * @returns {string[]} 数组
 */
export const splitStrByLineBreak = (str, separator = '\n') => {
  if (isBlank(str)) {
    return [];
  }
  return splitStr(str, separator);
};
